import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getUserAppRedirect,
  getUserApps,
  getUserOrganizations,
  getUserProfile,
} from "./action";
import {
  Application,
  Organization,
  OrganizationSlice,
  Profile,
  RedirectInfo,
} from "./type";

const initialState: OrganizationSlice = {
  profile: {
    defaultBrandId: "",
    defaultCountryId: "",
    email: "",
    name: "",
    phoneNo: "",
    profilePicture: "",
    userId: 0,
    username: "",
    role: 0,
  },
  organizations: [],
  applications: [],
  redirectInfo: {
    redirectUrl: "",
    jwtToken: "",
  },
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    resetApplications: (state) => {
      state.applications = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getUserProfile.fulfilled,
      (state, action: PayloadAction<Profile>) => {
        state.profile = action.payload;
        if (action.payload?.name) {
          localStorage.setItem("name", action.payload.name);
        }
      },
    );
    builder.addCase(
      getUserOrganizations.fulfilled,
      (state, action: PayloadAction<Organization[]>) => {
        state.organizations = action.payload;
      },
    );
    builder.addCase(
      getUserApps.fulfilled,
      (state, action: PayloadAction<Application[]>) => {
        state.applications = action.payload;
      },
    );
    builder.addCase(
      getUserAppRedirect.fulfilled,
      (state, action: PayloadAction<RedirectInfo>) => {
        state.redirectInfo = action.payload;
      },
    );
  },
});

export const { resetApplications } = organizationSlice.actions;

export default organizationSlice.reducer;
